import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Api from "../../Api";
import EntitySearch from "../../parts/EntitySearch";
import Section from "../../parts/Section";
import DiscreetMessage from "../../parts/DiscreetMessage";
import { Client } from "../../types";

const MyQuotesCreate1 = () => {
  const navigate = useNavigate();
  const [clients, setClients] = useState<Client[] | null>(null);

  return (
    <Section className="p-4 flex flex-col gap-4 pb-32">
      <div className="text-xl font-bold py-2 text-center">
        Novo orçamento para:
      </div>

      <EntitySearch
        searchFunction={Api.myQuotesSearchClients}
        setEntities={setClients}
      />

      {!clients && <DiscreetMessage text="Carregando ..." />}

      {clients && clients.length === 0 && (
        <DiscreetMessage text="Nenhum resultado" />
      )}

      {clients && (
        <div className="flex flex-col gap-4 py-4">
          {clients.map((client) => (
            <ClientCard
              key={client.uuid}
              client={client}
              onClick={() => navigate(`/meus-orcamentos/criar/${client.uuid}`)}
            />
          ))}
        </div>
      )}
    </Section>
  );
};

export default MyQuotesCreate1;

const ClientCard = ({
  client,
  onClick,
}: {
  client: Client;
  onClick: (client: Client) => void;
}) => (
  <div
    className="block border rounded-lg shadow-sm p-4 hover:bg-slate-50 cursor-pointer"
    onClick={() => onClick(client)}
  >
    <div className="overflow-scroll whitespace-nowrap no-scrollbar font-semibold">
      {client.name}
    </div>
  </div>
);
